import { format } from 'date-fns';

export interface IDeactivated {
  createdBy: string;
  createdAt: string;
  endDate: string;
}

export const getDeactivatedInfo = (deactivated: IDeactivated) => {
  const deactivatedTime = format(deactivated?.createdAt, 'dd/MM/yyyy');
  const activeTime = deactivated?.endDate && format(deactivated?.endDate, 'dd/MM/yyyy');
  const createdBy = deactivated?.createdBy.trim();

  return {
    deactivatedTime,
    activeTime,
    createdBy,
  };
};
